import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default_collection_active",
  "use": "default_collection_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"default_collection_active\"><g fill-rule=\"evenodd\" transform=\"translate(-77 -86)\"><path d=\"M78 92h18v1H78z\" /><rect width=\"18\" height=\"12\" x=\"78\" y=\"92\" opacity=\".9\" rx=\"1\" /><path d=\"M78 89a1 1 0 0 1 .99-1H84l2 2h-8v-1Zm0 1h17.007c.548 0 .993.444.993 1v1H78v-2Z\" opacity=\".6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol